"use strict";
exports.__esModule = true;
var rxjs_1 = require("rxjs");
var lax = require("lax.js");
var TWSlider_1 = require("./TWSlider");
var TWHorizontalScroll = /** @class */ (function () {
    function TWHorizontalScroll($element, ghostHeightPerItem) {
        if (ghostHeightPerItem === void 0) { ghostHeightPerItem = 400; }
        var _this = this;
        this.$element = $element;
        this.ghostHeightPerItem = ghostHeightPerItem;
        this.laxIstance = null;
        this.sliderIstance = null;
        if (!this.$element)
            return this;
        this.$ghostEl = this.$element.$(".HorizontalScrollSection__ghost");
        this.init();
        (0, rxjs_1.fromEvent)(window, "resize").subscribe(function () { return _this.init(); });
    }
    TWHorizontalScroll.prototype.getAnimationStartY = function () {
        var _a;
        var elementRect = this.$element.getBoundingClientRect();
        var top = elementRect.top + window.scrollY;
        var headerHeight = (_a = window.$(".Header")) === null || _a === void 0 ? void 0 : _a.offsetHeight;
        return top - headerHeight;
    };
    TWHorizontalScroll.prototype.getAnimationEndY = function () {
        var $stickyWrap = this.$element.$(".HorizontalScrollSection__sticky");
        var ghostRect = this.$ghostEl.getBoundingClientRect();
        var stickyWrapTop = window
            .getComputedStyle($stickyWrap, null)
            .getPropertyValue("top")
            .replace("px", "");
        var top = ghostRect.top +
            this.$ghostEl.offsetHeight -
            $stickyWrap.offsetHeight -
            this.getNumberFromProperty(stickyWrapTop);
        return top;
    };
    TWHorizontalScroll.prototype.getScrollWrapWidth = function () {
        var _this = this;
        var $wrap = this.$element.$(".HorizontalScrollSection__wrap");
        var $items = $wrap.$$(".item");
        var wrapGutter = this.getNumberFromProperty(window.getComputedStyle($wrap, null).getPropertyValue("margin-left")) * -2;
        var wrapWidth = $items.reduce(function (width, item) {
            var itemOffset = _this.getNumberFromProperty(window.getComputedStyle(item, null).getPropertyValue("margin-left"));
            var itemWidth = item.offsetWidth;
            return width + itemOffset + itemWidth;
        }, 0);
        return (wrapWidth - $wrap.offsetWidth - wrapGutter) * -1;
    };
    TWHorizontalScroll.prototype.setGhostHeight = function (height) {
        if (height === void 0) { height = null; }
        var $items = this.$element.$$(".item");
        this.$ghostEl.style.height =
            height !== null
                ? "".concat(height, "px")
                : "".concat($items.length * this.ghostHeightPerItem, "px");
    };
    TWHorizontalScroll.prototype.getNumberFromProperty = function (property) {
        if (property == null)
            return 0;
        return Number(property.replace("px", ""));
    };
    TWHorizontalScroll.prototype.isMobile = function (breakpointWidth) {
        if (breakpointWidth === void 0) { breakpointWidth = 768; }
        var innerWidth = window.innerWidth;
        return innerWidth < breakpointWidth;
    };
    TWHorizontalScroll.prototype.initHorizontalScroll = function () {
        this.setGhostHeight();
        this.laxIstance = lax;
        this.laxIstance.init();
        this.laxIstance.addDriver("scrollY", function () {
            return window.scrollY;
        });
        this.laxIstance.addElements(".HorizontalScrollSection__wrap", {
            scrollY: {
                translateX: [
                    [this.getAnimationStartY(), this.getAnimationEndY()],
                    [0, this.getScrollWrapWidth()],
                ]
            }
        });
    };
    TWHorizontalScroll.prototype.initSlider = function () {
        this.setGhostHeight(0);
        this.sliderIstance = new TWSlider_1["default"](".CaruselSection__items", this.$element.$(".HorizontalScrollSection__wrap"), 1, {
            cellAlign: "left",
            cellSelector: ".item",
            contain: true,
            draggable: true,
            groupCells: 1,
            prevNextButtons: false,
            wrapAround: false,
            watchCSS: true
        });
    };
    TWHorizontalScroll.prototype.init = function () {
        if (this.isMobile()) {
            if (this.laxIstance !== null) {
                // this.laxIstance.removeDriver("scrollY");
                this.laxIstance.removeElements(".HorizontalScrollSection__wrap");
                this.$element.$(".HorizontalScrollSection__wrap").style.transform =
                    "unset";
            }
            this.initSlider();
        }
        else {
            if (this.sliderIstance !== null)
                this.sliderIstance = null;
            this.initHorizontalScroll();
        }
    };
    return TWHorizontalScroll;
}());
exports["default"] = TWHorizontalScroll;
